import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52cd3685"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opening-detail-wrapper" }
const _hoisted_2 = { class: "register-detail" }
const _hoisted_3 = { class: "item text-overflow" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "公司名称：", -1))
const _hoisted_5 = {
  class: "item text-overflow",
  style: {"width":"350px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "联系电话：", -1))
const _hoisted_7 = { class: "item text-overflow" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "开户银行：", -1))
const _hoisted_9 = { class: "item text-overflow" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "银行账户号码：", -1))
const _hoisted_11 = {
  class: "item text-overflow",
  style: {"width":"500px"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, " 税号：", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "item text-overflow" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "正式开业时间：", -1))
const _hoisted_16 = { class: "item text-overflow" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "地址：", -1))

import {
  ref,
  reactive,
  watch,
  onMounted,
  withDefaults,
  getCurrentInstance,
} from "vue";
import { getBankAccountRegistration } from "@/api/process_bank";

export default /*#__PURE__*/_defineComponent({
  props: {
    detail: { default: () => {
      return {
        Id: 0,
        CompanyName: "",
        ContactPhone: "",
        TaxNo: "",
        OpenAccountBank: "",
        BankAccount: "",
        Address: "",
        GrandOpenTime: "",
      };
    } }
  },
  setup(__props: any) {

const props = __props as { detail: {
      Id: number;
      CompanyName: string;
      ContactPhone: string;
      TaxNo: string;
      OpenAccountBank: string;
      BankAccount: string;
      Address: string;
      GrandOpenTime: string;
    } }



return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(props.detail.CompanyName), 1)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(props.detail.ContactPhone), 1)
      ]),
      _createElementVNode("span", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(props.detail.OpenAccountBank), 1)
      ]),
      _createElementVNode("span", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(props.detail.BankAccount), 1)
      ]),
      _createElementVNode("span", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", null, _toDisplayString(props.detail.TaxNo), 1)
      ]),
      _hoisted_13,
      _createElementVNode("span", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("span", null, _toDisplayString(props.detail.GrandOpenTime), 1)
      ]),
      _createElementVNode("span", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_a_tooltip, null, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.detail.Address), 1)
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(props.detail.Address), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})